// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAdjust = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M17.83 13a3.001 3.001 0 01-5.66 0H4v-2h8.17a3.001 3.001 0 015.66 0H20v2zM16 12a1 1 0 11-2 0 1 1 0 012 0m-4.17-5a3.001 3.001 0 01-5.66 0H4V5h2.17a3.001 3.001 0 015.66 0H20v2zM10 6a1 1 0 11-2 0 1 1 0 012 0m1.83 13a3.001 3.001 0 01-5.66 0H4v-2h2.17a3.001 3.001 0 015.66 0H20v2zM10 18a1 1 0 11-2 0 1 1 0 012 0"
    />
  );
export default SvgIconAdjust;
